import { defineMessages } from "react-intl";

export const exitFormPromptMessages = defineMessages({
  unableToSaveTitle: {
    id: "c5fFin",
    defaultMessage: "Leave without saving changes?",
    description: "ExitFormPrompt title",
  },
  keepEditing: {
    id: "ySqncG",
    defaultMessage: "Keep editing",
    description: "ExitFormPrompt keep editing button",
  },
  ignoreChanges: {
    id: "blZJmA",
    defaultMessage: "Ignore changes",
    description: "ExitFormPrompt ignore changes button",
  },
});
